import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Marchand "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Taux "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " User Max "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Produit Max "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Categorie "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Infos supplémentaire "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
    }, "ACTIONS")
  ])
], -1)
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = { class: "badge badge-outline-danger text-outline-primary" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete icon-position" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_25 = { class: "dropdown" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_31 = { key: 1 }
const _hoisted_32 = ["href"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_34 = { key: 2 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_37 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddNewCategorieModal = _resolveComponent("AddNewCategorieModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.checkPermission('AddContrat'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                to: "/ajouter-contrat"
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode(" Ajouter un contrat ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un contrat"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _hoisted_6
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contrats, (contrat, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(contrat?.marchand.nom) + " " + _toDisplayString(contrat?.marchand.prenom) + " " + _toDisplayString(contrat?.marchand.raisonSocial), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(contrat.tauxEconomique), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(contrat.userMax), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(contrat.produitMax), 1),
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contrat.categories, (categorie) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: categorie.id,
                          class: "badge-container"
                        }, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, [
                              _createTextVNode(_toDisplayString(categorie.name) + " ", 1),
                              _createElementVNode("a", {
                                href: "javascript:void(0);",
                                class: "tag-delete-link text-outline-danger",
                                onClick: ($event: any) => (_ctx.suppCat(contrat.id,categorie.id))
                              }, _hoisted_21, 8, _hoisted_19)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("p", {
                      innerHTML: contrat.infosSupplementaire.slice(0, 20) + '...'
                    }, null, 8, _hoisted_23)
                  ]),
                  _createElementVNode("td", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("ul", _hoisted_27, [
                        (_ctx.checkPermission('AddContratCategorie'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "#",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#AddNewCategorieModal",
                                onClick: ($event: any) => (_ctx.openAddNewCategorieModal(contrat))
                              }, [
                                _hoisted_30,
                                _createTextVNode(" Ajouter de (s) catégorie (s) ")
                              ], 8, _hoisted_29)
                            ]))
                          : _createCommentVNode("", true),
                        (contrat.urlImage)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                target: "_blank",
                                href: _ctx.getUrlApiForFiles(contrat.urlImage)
                              }, [
                                _hoisted_33,
                                _createTextVNode(" Télécharger contrat ")
                              ], 8, _hoisted_32)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('DeleteContrat'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.suppression(contrat.id,_ctx.contrats,'contrats',`le contrat de ${contrat.marchand.nom}`))
                              }, [
                                _hoisted_36,
                                _createTextVNode(" Supprimer ")
                              ], 8, _hoisted_35)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddNewCategorieModal, {
      selectedContrat: _ctx.selectedContrat,
      selectedContratId: _ctx.selectedContratId,
      onClose: _ctx.recharger
    }, null, 8, ["selectedContrat", "selectedContratId", "onClose"])
  ], 64))
}